export const userColumns = [

    {
        field: "bedNumber",
        headerName: "Bed Number",
        width: 200,
    },
    {
        field: "bedStatus",
        headerName: "Bed Status",
        width: 150,
    },
    {
        field: "activeStatus",
        headerName: "Active Status",
        width: 150,
    },
    {
        field: "description",
        headerName: "Description",
        width: 150,
    },

];